export default "__VITE_ASSET__Wm466HCm__"